import { Card, Elevation } from "@blueprintjs/core";
import { FGSelectInput, FGTextInput } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";

import { EDogSex } from "../../../../api";
import { useGlobalData } from "../../../../contexts";
import { useTl } from "../../../../hooks";
import { useReferential } from "../../../../hooks/useReferential";
import { ETLCodes } from "../../../../locales";

export interface IDrupalParentInfoBoxProps {
  name: string;
  chipNumberFG: string;
  pedigreeFG: string;
  breedFG: string;
  colorFG: string;
  sex: EDogSex;
  undefinedParent?: boolean;
}

const MainContainer = styled(Card)`
  width: 40rem;
  height: 15rem;
  padding: 0px;
  margin: auto;
  margin-bottom: 1rem !important;
  display: flex;
  flex-direction: row;
`;

const Container = styled.div`
  height: 15rem;
  width: 40rem;
  margin-left: 0.5rem;
  background-color: #ffffff;
  border-radius: 3px;
`;

export const DrupalParentInfoBox: React.FunctionComponent<IDrupalParentInfoBoxProps> = ({
  name,
  chipNumberFG,
  pedigreeFG,
  breedFG,
  colorFG,
  sex,
  undefinedParent = false,
}) => {
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();

  const [breeds, breedLoading] = useReferential((a) => a.getBreeds(null));
  const [colors, colorLoading] = useReferential((a) => a.getColors(currentLanguage.languageId));

  //TODO: FIX gender COlors
  //TODO CRR : useless?
  // const genderColor = React.useMemo(() => {
  //   if (undefinedParent) {
  //     return "#B6B3B3";
  //   } else {
  //     return sex === EDogSex.Male ? "#0091ff" : "#F374CE";
  //   }
  // }, [sex, undefinedParent]);

  return (
    <MainContainer interactive={true} elevation={Elevation.FOUR}>
      {undefinedParent ? (
        <h2 style={{ fontSize: "25px", marginLeft: "3rem", marginBottom: "1rem" }}>{t(ETLCodes.UndefinedFather)}</h2>
      ) : (
        <Container>
          <h2 style={{ fontSize: "25px", marginLeft: "3rem", marginBottom: "1rem" }}>
            {`${sex === EDogSex.Male ? t(ETLCodes.Father) : t(ETLCodes.Mother)} : ${name}`}
          </h2>
          <div style={{ marginLeft: "2rem" }}>
            <FGTextInput name={pedigreeFG} label={t(ETLCodes.Pedigree)} />
            <FGTextInput name={chipNumberFG} label={t(ETLCodes.Chip)} />
            <FGSelectInput items={breeds} loading={breedLoading} name={breedFG} label={t(ETLCodes.Breed)} />
            <FGSelectInput items={colors} loading={colorLoading} name={colorFG} label={t(ETLCodes.Color)} />
          </div>
        </Container>
      )}
    </MainContainer>
  );
};
